/**
 * Layout constants for consistent spacing and sizing across the app
 */

/**
 * Header/AppBar heights matching MUI Toolbar defaults
 * - xs: Mobile devices
 * - sm: Tablet and desktop
 */
export const HEADER_HEIGHT = {
  xs: 56,
  sm: 64,
} as const;

/**
 * Default header height for calculations (uses desktop size)
 */
export const HEADER_HEIGHT_DEFAULT = HEADER_HEIGHT.sm;

/**
 * Drawer width for navigation sidebar
 */
export const DRAWER_WIDTH = 240;

/**
 * MUI Accordion animation duration in milliseconds
 * Used for scroll synchronization during accordion expansion
 */
export const ACCORDION_ANIMATION_DURATION = 300;

/**
 * Default scroll padding from top of viewport (in pixels)
 * Used when scrolling elements into view to avoid being flush with the top
 */
export const SCROLL_PADDING_TOP = 16;
